export const messages = {
    "Exit":"Выйти",
    "Login":"Вход",
    "Registration":"Регистрация",
    "Save":"Сохранить",
    "Administration":"Администрирование",
    "Main":"Главная",
    "About":"О проекте",
    "Social objects":"Социальные объекты",
    "Employment":"Трудоустройство",
    "Events":"События",
    "Documents":"Документы",
    "Monitorings, reports":"Мониторинги, отчеты",
    "For parents":"Родителям",
    "For specialists":"Специалистам",
    "Ask a question":"Задать вопрос",
    "Services":"Сервисы",
    "Language":"Язык",
    "English":"Русский",
    "Сhoose the language":"Выбрать язык",
    "visually impaired":"слабовидящим",
    "Navigator of Inclusive Education of the Republic of Bashkortostan":"Навигатор инклюзивного образования Республики Башкортостан",
    "Information portal":"Информационный портал",
    "Search":"Поиск",
    "Publication date":"Дата публикации",
    "Photo Collection":"Коллеция фотографий",
    "Close":"Закрыть",
    "Events settings":"Настройка событий",
    "Click to set up the event page":"Нажмите, чтобы настроить страницу событий",
    "Configure the event page":"Настройте страницу событий",
    "Author":"Автор",
    "Header":"Заголовок",
    "Text":"Текст",
    "Link of the 1st photo":"Ссылка 1-го фото",
    "Link of the 2nd photo":"Ссылка 2-го фото",
    "Link of the 3rd photo":"Ссылка 3-го фото",
    "Link of the 4th photo":"Ссылка 4-го фото",
    "Link of the 5th photo":"Ссылка 5-го фото",
    "Link of the 6th photo":"Ссылка 6-го фото",
    "Link of the 7th photo":"Ссылка 7-го фото",
    "Link of the 8th photo":"Ссылка 8-го фото",
    "Link of the thumbnail":"Ссылка миниатюры",
    "Do you want to delete an event?":"Хотите удалить событие?",
    "Do you want to delete a file?":"Хотите удалить файл?",
    "Do you want to delete a recommendation?":"Хотите удалить рекомендацию?",
    "Do you want to delete a question?":"Хотите удалить вопрос?",
    "Do you want to delete a specialization?":"Хотите удалить специальность?",
    "Do you want to delete a organization?":"Хотите удалить организацию?",
    "Authorization":"Авторизация",
    "Password":"Пароль",
    "Log in":"Войти",
    "Your name":"Ваше имя",
    "Register as specialist":"Зарегистрироваться как специалист",
    "I agree with the privacy policy and consent to the processing of personal data":"Я согласен с политикой конфиденциальности и даю согласие на обработку персональных данных",
    "Register":"Зарегистрироваться",
    "Questions to me":"Вопросы мне",
    "My questions":"Мои вопросы",
    "Question":"Вопрос",
    "Answer":"Ответ",
    "Edit the answer":"Редактировать ответ",
    "Comments":"Комментарии",
    "Add comment":"Добавить комментарий",
    "Add answer":"Добавить ответ",
    "Cancel":"Отмена",
    "Subject":"Тема",
    "Choose a specialist":"Выберите специалиста",
    "Message":"Сообщение",
    "Send":"Отправить",
    "For ask a question to specialists, please log in":"Чтобы задать вопрос специалистам, пожалуйста, авторизуйтесь",
    "Please wait for the registration process to complete":"Пожалуйста, дождитесь завершения процесса регистрации",
    "Select the specialist you want to ask a question":"Выберите специалиста, которому вы хотите задать вопрос",
    "Nothing found":"Ничего не найдено",
    "Add a new specialization to the list":"Добавьте новую специализацию в список",
    "Add a new disease to the list":"Добавьте новое заболевание в список",
    "Add a new organization to the list":"Добавьте новую организацию в список",
    "Your full name":"Ваше полное имя",
    "Address":"Адрес",
    "Your insurance number of an individual personal account (СНИЛС)":"Ваш страховой номер индивидуального лицевого счета (СНИЛС)",
    "Your phone number":"Ваш номер телефона",
    "Your child's date of birth":"Дата рождения Вашего ребенка",
    "Your child's gender":"Пол вашего ребенка",
    "Select a specialty":"Выберите специальность",
    "Select an organization":"Выберите организацию",
    "Select a disease":"Выберите заболевание",
    "The category of your child with disabilities":"Категория Вашего ребенка с ОВЗ",
    "What grade does your child study in?":"В каком классе учится Ваш ребенок?",
    "There is no answer yet":"Ответа пока нет",
    "There is no comment yet":"Комментариев пока нет",
    "Your email":"Ваш email",
    "Information":"Информация",
    "Forgot your password?":"Забыли пароль?",
    "Reset Password":"Сбросить пароль",
    "New password":"Новый пароль",
    "Documents settings":"Настройка документов",
    "Click to set up documents":"Нажмите, чтобы настроить документы",
    "Date":"Дата",
    "Chapter":"Раздел",
    "Publisher":"Издатель",
    "Status":"Статус",
    "Type":"Тип",
    "Grade":"Категория",
    "Name":"Название",
    "File":"Файл",
    "Setting up documents":"Настройка документов",
    "Recommendations of specialists":"Рекомендации специалистов",
    "Recommendations for specialists":"Рекомендации для специалистов",
    "Working with files":"Работа с файлами",
    "Click to add/remove files":"Нажмите, чтобы добавить/удалить файлы",
    "Recommendations":"Рекомендации",
    "Click to edit recommendations":"Нажмите, чтобы редактировать рекомендации",
    "My recommendations":"Мои рекомендации",
    "Add recommendation":"Добавить рекомендации",
    "Title":"Заголовок",
    "Recommendation":"Рекомендация",
    "Setting up recommendations":"Настройка рекомендаций",
    "Add a new chapter":"Добавьте новый раздел",
    "Add a new publisher":"Добавьте нового издателя",
    "Add a new status":"Добавьте новый статус",
    "My files":"Мои файлы",
    "LE Registration":"Регистрация ЮЛ",
    "LE Authorization":"Авторизация ЮЛ",
    "District/City":"Район/Город",
    "Log in to the IS Monitoring":"Войти в ИС Мониторинг",
    "Literature":"Литература",
    "Materials":"Материалы",
    "List of users":"Список пользователей",
    "Click to work with users":"Нажмите, чтобы работать с пользователями",
    "List of specialists":"Список специалистов",
    "Click to see the specialists":"Нажмите, чтобы посмотреть специалистов",
    "List of organizations":"Список организаций",
    "Click to see the organizations":"Нажмите, чтобы посмотреть организации",
    "List of specializations":"Список специальностей",
    "Click to see the specializations":"Нажмите, чтобы посмотреть специальности",
    "Activity of specialists":"Активность специалистов",
    "Click to see the activity of specialists":"Нажмите, чтобы посмотреть активность специалистов",
    "Ministry of Education of the Russian Federation":"Министерство просвещения РФ",
    "Institute of Correctional Pedagogy  of the":"Институт коррекционной педагогики",
    "Ministry of Education and Science of the RB":"Министерство образования и науки РБ",
    "Ministry of Education of the RB":"Министерство просвещения РБ",
    "Institute of Education Development of the RB":"Институт развития образования РБ",
    "Official Internet portal of legal information":"Официальный интернет-портал правовой информации",
    "Delete":"Удалить",
    "All questions":"Все вопросы",
    "Click to see the all questions":"Нажмите, чтобы посмотреть все вопросы",
    "Feedback":"Отзыв",
    "To feedback, please log in.":"Чтобы оставить отзыв, пожалуйста, войдите в систему.",
    "Feedbacks":"Отзывы",
    "Click to see the all feedbacks":"Нажмите, чтобы посмотреть все отзывы",
    "Distance Education Teacher":"Учитель дистанционного образования",
    "Nosologies":"Нозологии",
    "Current password":"Старый пароль",
    "Change the password":"Изменить пароль",
    "Save the password":"Сохранить пароль",
    "Proud of you, our graduate!":"Горжусь тобой, наш выпускник!",
    "Back":"Назад",
    "Graduate":"Выпускник",
    "School":"Школа",
    "Municipality":"Муниципальное образование",
    "Viewed":"Просмотрено",
    "Video":"Видео",
    "Click to add videos for the page 'Proud of you, our graduate!'":"Нажмите, чтобы добавлять видео для страницы 'Горжусь тобой, наш выпускник!'",
    "Moderate videos":"Модерировать видео",
    "Click to see the all videos and moderate them":"Нажмите, чтобы увидеть все видео и модерировать их",
    "Full name of the graduate":"ФИО выпускника полностью",
    "Name of school":"Наименование школы",
    "Graduation year":"Год выпуска",
    "Code for embedding video":"Код встраивания видео",
    "Configure the video page":"Настройки видео",
    "The video is not moderated":"Видео не прошло модерацию",
    "Approve":"Опубликовать",
    "Remove from approval":"Снять с публикации",
    "Do you want to delete a video?":"Хотите удалить видео?",
    "Professional testing":"Профтестирование",
    "Career guidance":"Профориентация",
    "Atlas of professions":"Атлас профессий",
    "Answer-Question":"Вопрос-Ответ",
    "New ones first":"Сначала новые",
    "Old ones first":"Сначала старые",
    "Schools for teaching children with ASD in the Republic":"Опорные школы по обучению детей с РАС в РБ",
    "Organizations that help children with":"Организации оказывающие помощь  детям",
    "Education for Children with ASD":"Обучение детей с РАС",
    "Interactive Map of Social Facilities":"Интерактивная карта социальных объектов",
    "Educational Facilities":"Объекты образования",
    "Employment Centers and Organizations Providing Rehabilitation Services":"Центры занятости, организации, предоставляющие реабилитационные услуги",
    "Healthcare Facilities":"Объекты здравоохранения",
    "Regional Personnel Registry":"Региональный кадровый реестр",
    "Specialists in psychological and pedagogical support for students with disabilities":"Специалисты психолого-педагогического сопровождения обучающихся с ОВЗ",

    // Организации родителей / фонды
    "ANO \"RASSVET\"":"АНО «РАССВЕТ»",
    "MAOU \"City Center ProDobro\", Ufa":"МАОУ «Городской центр «ПроДОбро» г. Уфа",
    "Regional parents’ organization of children with disabilities of the RB":"Региональная общественная организация родителей детей с инвалидностью РБ",
    "ANO \"Clear Mind\" (adaptive & inclusive programs for people with ASD)":"АНО «Чистый разум» (адаптивные и инклюзивные программы для лиц с РАС)",
    "Council of Mothers \"Materinskoe Serdce\" of the RB":"Совет матерей «Материнское сердце» РБ",
    "Charitable Educational Foundation \"Markhamat\"":"Благотворительный образовательный фонд «Мархамат»",

    // Центры ментального здоровья
    "Mental Health Center (RCPPMCP) — Ufa":"Центр ментального здоровья (РЦППМСП) — Уфа",
    "Mental Health Center (RCPB)":"Центр ментального здоровья (РКПБ)",
    "Mental Health Center — FRC TMNR":"Центр ментального здоровья — ФРЦ ТМНР",
    "Mental Health Center — FCIO":"Центр ментального здоровья — ФЦИО",
    "Mental Health Center — FRC ASD":"Центр ментального здоровья — ФРЦ РАС",
}
